import React from 'react'
import style from './about.module.css'
// import image from '../../assets/aboutInfo2.png'
import crypto1 from '../../assets/crypto1.png'
import crypto2 from '../../assets/crypto2.png'
import data from '../../database/data';
import Whyus from '../../components/whyUs/Whyus';
import Heading from '../../components/heading/Heading'
import AboutStats from '../../components/aboutStats/AboutStats';
import Team from '../../components/team/Team'
import {Link} from 'react-router-dom'
import Footer1 from '../../components/footer1/Footer1';
import Needsolution from '../../components/needSolution/Needsolution';
import map from '../../assets/map-pattern-1.png'

const About = () => {
  // console.log(data.aboutStatsData)
  return (
    <div className={style.aboutMain}>
    
    <div className={style.mainSection}>
      <div className={style.mainSectionContainer}>
        <Heading
         heading="About"
        />
        <div className={style.mainSectionContent}>
          <div>
            <img src={map} alt="" />
            <h2>We believe that technology can change the world.</h2>
          </div>
          <div>
            <p>Welcome to AradChain Technologies, where innovation meets transformation. We are a leading provider of cutting-edge solutions designed to empower individuals and businesses alike to harness the immense power of emerging technologies.</p>
            <p>With a focus on blockchain, cloud computing, artificial intelligence, and the Internet of Things (IoT), we are at the forefront of the digital revolution. With our global headquarters in Dubai International Finance Centre and offices in Bahrain and the City of London,  we believe that technology has the potential to reshape industries, streamline operations, and unlock new possibilities. Our team of experts is dedicated to delivering state-of-the-art solutions that drive efficiency, enhance security, and facilitate seamless integration across diverse sectors.</p>
          </div>
          
        </div>
      </div>
    </div>
    

    {/* Info Section */}
    <div className={style.infoSection}>
      <div className={style.infoContainer}>
        <div className={style.infoTop}>
        {
                  data.about.map((ele)=>{
                    return (
                      <Whyus
                      key={ele.id}
                      image={ele.image}
                      title={ele.title}
                      desc={ele.desc}
                      alt={ele.title}
                      />
                    )
                  })
                }
        </div>
        <div className={style.infoBottom}>
          {
            data.aboutStatsData.map((ele)=>{
              return(
                <AboutStats
                number={ele.number}
                text={ele.text}
                />
              )
            })
          }
        </div>
      </div>
    </div>


    {/* Crypto Section */}
    {/* <div className={style.cryptoSection}>
        <div className={style.cryptoContainer}>
          <img src={crypto1} alt="crypto1" />
          <img src={crypto2} alt="crypto2" />
        </div>
    </div> */}



    {/* Our Team */}
    <div className={style.ourTeamSection}>
        <div className={style.ourTeamContainer}>
          <h1>Our Team</h1>
          <p>The passionate people who drive our projects in Aradchain Technologies.</p>
          <div className={style.teamBoxes}>
            {
              data.team.map((ele)=>{
                return(
                  <Team
                    key={ele.id}
                    image={ele.image}
                    desg={ele.desg}
                    name={ele.name}
                    link={ele.link}
                  />
                )
              })
            }
          </div>
        </div>
    </div>

    {/* Need Solution */}
    <Needsolution/>


    {/* Footer Section */}
    <Footer1/>

    </div>

    
  )
}

export default About
